import React from 'react';
import PropTypes from 'prop-types';
import './UserTraining.scss';
import Feed from 'components/Feed';

export default class UserTraining extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {


        const myTraining = [
            {
                title: 'The NOON Lighting System',
                category: '',
                description: 'This training module covers features, installation, the NOON app and common troubleshooting.',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/noon-lifestyle-father-and-son.jpg',
                download: false,
                link: '/user/training/training01',
                ctaLable: 'New Training'
            },
        ];

        const tMaterials = [
            {
                title: 'The NOON Lighting System',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/thumb-the-noon-lighting-system.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/the-noon-lighting-system.pdf',
                download: true,
                ctaLable: 'Download',
            },
            {
                title: 'NOON Features',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/video1.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/2.+Noon+Features.mp4',
                download: false,
                ctaLable: 'Watch Video',
            },
            {
                title: 'Preparing for your NOON Installation',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/video2.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/3.+Preparing+for+your+Noon+Installation.mp4',
                download: false,
                ctaLable: 'Watch Video',
            },
            {
                title: 'Installing NOON',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/video3.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/4.+Installing+Noon.mp4',
                download: false,
                ctaLable: 'Watch Video',
            },
            {
                title: 'Installing NOON Multi-way',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/video4.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/5.+Installing+Noon+-+MultiWay.mp4',
                download: false,
                ctaLable: 'Watch Video',
            },
            {
                title: 'NOON App Bulb ID',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/video5.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/6.+Noon+App+_+Bulb+ID.mp4',
                download: false,
                ctaLable: 'Watch Video',
            },
            {
                title: 'Troubleshooting',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/video6.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/7.+Troubleshooting.mp4',
                download: false,
                ctaLable: 'Watch Video',
            },
            {
                title: 'Traning videos',
                category: '',
                description: '',
                featuredImage: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/video8.jpg',
                link: 'https://s3-us-west-2.amazonaws.com/com-noonhome-pro-assets-prod/training-videos/8.+Extended+Support.mp4',
                download: false,
                ctaLable: 'Watch Video',
            },

        ]

        return (
            <section className='training--container'>
                <h1>Stay up to date on NOON training</h1>
                <h6 className='training-title'>Available Training</h6>
                <Feed proFeeds={myTraining}/>
                <h6 className='training-title'>Additional Training Material</h6>
                <Feed proFeeds={tMaterials}/>
            </section>
        )
    }

};


// WEBPACK FOOTER //
// ./src/routes/UserTraining/index.js